import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_79: FaireProductEntity = {
  token: "catalog_prod_prod-79",
  type: "product",
  name: "Wall Decor",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 27.94,
  msrpDollars: 69.85,
  sku: "AN0079",
  caseSize: 6,
  material: "Linen",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 211,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_womens-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
